import Utility from 'Core/Utility';
import moment from 'moment';
import { SecuredAPMProxyClient } from 'Core/Api/APMProxy/SecuredAPMProxyClient';

export class CustomerBolHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  GetCustomerBol(customerCode: string) {
    let client = new SecuredAPMProxyClient();
    client.showLoading = true;
    client.handleGeneralError = true;

    return client.getBLbyConsignee(customerCode).catch(Utility.formatError);
  }


}
